import getHousesList from '@r1-frontend/api-domru/api-profile/v1/address/get-house-list';
import { doRequest } from '@r1-frontend/do-request';

import { getStreets } from '~/src/api/content/street';

// @deprecated
export const parseGetHousesResp = (data) => {
    if (!Array.isArray(data)) {
        return [];
    }

    return data.map((item) => ({
        id: Number(item.house_id.data[0].value),
        number: String(item.house_num.data[0].value),
    }));
};

// получаем данные для улицы, чтобы отправить заявку потенциального клиента
export const getStreetData = async() => {
        const resp = await getStreets({ providerId: 47, term: 'Программистов' });
        const street = resp.isSuccess && resp.items?.length ? resp.items[0] : {};

        const data = await doRequest.apiProfile(
            getHousesList({ streetId: street.street_id }),
        );

        if (data.isSuccess) {
            const house = parseGetHousesResp(data)
                .filter(
                    item => item.number.toLowerCase() === '1',
                )[0] || data[0];

            return {
                street: street.street_id,
                streetName: 'Программистов',
                house: '1',
                houseId: house.id,
                office: '1',
            };
        } else {
            return {
                street: '1',
                streetName: 'Программистов',
                house: '1',
                houseId: '1',
                office: '1',
            };
        }
};
